var _ = require("lodash");

import axios from "axios";
import store from "./store";
import VueAxios from "vue-axios";

export default () => {
    const HandleError = (res) => {
        let status = 200;
        if (res && res.data && res.data.status) status = res.data.status;

        if (`${status}`.charAt(0) == 4 || `${status}`.charAt(0) == 5) {
            if (status == 422 && res.data.data.errors.errors){
                res.data.data.errors = res.data.data.errors.errors;
            }

            return Promise.reject(
                res ? (res.data ? { response: res.data } : res) : ""
            );
        }
        return Promise.resolve(res);
    };

    const instance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${store.getters.apiToken}`,
        },
        params: {
            conference_id: process.env.VUE_APP_CONFERENCE_ID,
        },
    });

    instance.interceptors.response.use(
        (response) => HandleError(response),
        (error) => HandleError(error)
    );

    return instance;
};

export { axios, VueAxios };
